import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
    margin: theme.spacing(1),
  },
  title: {
    fontSize: 14,
    textAlign: 'center',
    padding: theme.spacing(1),
  },
  tableCell: {
    padding: theme.spacing(1),
  },
  totalLabel: {
    fontSize: 14,
  },
}));

export default useStyles;
